import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that wraps matching search terms in <mark> tags for visual highlighting.
 * Escapes both the input text and search term to prevent HTML injection.
 *
 * Usage: <span [innerHTML]="tutorial.Title | highlight: searchText"></span>
 */
@Pipe({
  name: 'highlight',
  standalone: false
})
export class HighlightPipe implements PipeTransform {
  transform(value: string | null | undefined, searchTerm: string): string {
    if (!value) {
      return '';
    }
    if (!searchTerm?.trim()) {
      return this.escapeHtml(value);
    }

    const escaped = this.escapeHtml(value);
    const escapedTerm = this.escapeHtml(searchTerm.trim());
    // Escape regex special characters in the search term
    const regexSafe = escapedTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${regexSafe})`, 'gi');
    return escaped.replace(regex, '<mark>$1</mark>');
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
  }
}
